import { useEffect, useCallback, useState } from "react";
import { useLocation, useOutletContext } from "react-router-dom";
import unityPlayerApi from "../../../../unity-player/player-api/api";
import { useBoundStore } from "../../../../zustand/store";
import { UseViewerControllerInterface } from "./viewer-props.interface";

const useViewerController = ({
  loaderConfig,
  onLoadSuccessCallback,
  onLoadErrorCallback,
}: UseViewerControllerInterface) => {
  const location = useLocation();
  const [unityPlayerLoadProgress, setUnityPlayerLoadProgress] = useState(0);
  // @ts-ignore
  const { unityPlayerInstance, setUnityPlayerInstance, setUnityPlayerCanvasIsBeingUsed, unityPlayerCanvasIsBeingUsed } = useBoundStore(
    (state) => state
  );

  // * the 'storedCurrentLocation' is used to determine wether the viewer-destroying cleanup function should be run
  const [storedCurrentLocation] = useState(location);


  // TODO: try to CAREFULLY move these into Zustand context;
  // @ts-ignore
  const {unityPlayerCanvasRef, unityPlayerCanvasBuilt} = useOutletContext();
  const setLoaderScript = useCallback((onLoadCallback: Function) => {
    const script = document.createElement("script");
    script.src = loaderConfig.loaderUrl as string;
    script.onload = () => {
      onLoadCallback();
    };

    document.body.appendChild(script);
    // eslint-disable-next-line
  }, []);

  const cleanupUnityPlayer = async () => {
    setUnityPlayerCanvasIsBeingUsed(false)
    console.log("Quitting Unity Player Instance...");
    // @ts-ignore
    await unityPlayerApi.quitUnityPlayerInstance(unityPlayerInstance, () =>
      console.log("Unity Player Instance Successfully Quitted")
    );

    // Removing the 'framework.js(.gz)' script
    Array.from(document.scripts)
      .filter((script: HTMLElement) =>
        // @ts-ignore
        [loaderConfig.frameworkUrl].includes(script.src)
      )
      .forEach((script) => script.remove());

    setUnityPlayerInstance(null);
  };

  const createPlayerInstance = () => {
    setUnityPlayerCanvasIsBeingUsed(true);
    unityPlayerApi.createUnityInstance(
        unityPlayerCanvasRef.current,
        // @ts-ignore
        loaderConfig,
        (progress: number) => {
          // * Load percentage status: 100 * progress;
          setUnityPlayerLoadProgress(progress)
        }
      )
      // ! this is pretty much the "onSuccess" event callback
      .then((unityInstance: any) => {
        setUnityPlayerInstance(unityInstance);
        if (onLoadSuccessCallback) onLoadSuccessCallback(unityInstance);
      })
      // ! and this is pretty much the "onError" event callback
      .catch((message: string) => {
        alert(message);
        if (onLoadErrorCallback) onLoadErrorCallback();
      });
  };

  useEffect(() => {
    if (!unityPlayerApi.isPlayerInstantiationFunctionAvailable()) {
      setLoaderScript(createPlayerInstance);
    } else if (!unityPlayerInstance) {
      createPlayerInstance();
    }

    // ! this cleanup function is the key to not raise an exception when navigating outside a view that uses this viewer component
    return () => {
      // @ts-ignore
      if (location.pathname.match(storedCurrentLocation) && unityPlayerInstance) {
        cleanupUnityPlayer();
      }
    };
    // eslint-disable-next-line
  }, [unityPlayerInstance]);

  return {unityPlayerCanvasBuilt, unityPlayerCanvasIsBeingUsed, unityPlayerLoadProgress }
};

export default useViewerController;
